<template>
  <div>
    <label for="productSelect">Product:</label>
    <select id="productSelect" class="form-select" v-model="selectedProduct" @change="onProductChange">
      <option v-for="product in products" :key="product.id" :value="product.id">
        {{ product.name }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue';

const props = defineProps({
  products: Array,
  modelValue: String
});

const emits = defineEmits(['update:modelValue', 'product-changed']);

const selectedProduct = ref(props.modelValue);

watch(() => props.modelValue, (newValue) => {
  selectedProduct.value = newValue;
});

watch(selectedProduct, (newValue) => {
  emits('update:modelValue', newValue);
});

const onProductChange = () => {
  emits('product-changed', selectedProduct.value);
};
</script>
